import React from 'react'
import { message } from 'antd'
import axios from 'axios'
import Hashids from 'hashids'
import ClassInfo from '../message'
import { Base64 } from 'js-base64'
import './index.less'

// 获取课程ID   4179
// 跳到直播页面

// https://room.yunkaodian.com/course/:id

const hashids = new Hashids()

class Entry extends React.Component<any, any> {
	constructor(props: any) {
		super(props)
		this.state = {
			username: '',
			classId: '',
			password: '',
			courseName: '',
			lecturer: '',
			time: '',
			is_live: false,
			url: '',
		}
		this.handleInputChange = this.handleInputChange.bind(this)
		this.getClassInfo = this.getClassInfo.bind(this)
		this.entryPlay = this.entryPlay.bind(this)
		this.entryLive = this.entryLive.bind(this)
	}

	public handleInputChange(event: any) {
		const target = event.target
		const value = target.type === 'checkbox' ? target.checked : target.value
		const name = target.name
		this.setState({
			[name]: value,
		})
	}

	public formDate(num: number) {
		return num < 10 ? `0${num}` : `${num}`
	}

	public componentDidMount() {
		let pathname = window.location.pathname

		let urls = pathname.split('/')
		let classId = urls[urls.length - 1]
		if (!classId) {
			return
		}

		axios
			.get(`https://room.yunkaodian.com/course/${classId}`)
			.then((res: any) => {
				let data = res.data
				if (data.code === 200) {
					let end_time = data.data.course.end_time
					let start_time = data.data.course.start_time
					let courseName = data.data.course.name
					let lecturer = data.data.zhubo.nickname
					let time = `${this.formDate(
						new Date(start_time).getFullYear()
					)}-${this.formDate(
						new Date(start_time).getMonth() + 1
					)}-${this.formDate(
						new Date(start_time).getDate()
					)} ${this.formDate(
						new Date(start_time).getHours()
					)}:${this.formDate(
						new Date(start_time).getMinutes()
					)}-${this.formDate(
						new Date(end_time).getHours()
					)}:${this.formDate(new Date(end_time).getMinutes())}`

					this.setState({
						courseName,
						lecturer,
						time,
					})
					// console.log(courseName, lecturer, time)
				}
			})

		this.setState(
			{
				classId: hashids.decode(classId)[0],
			},
			() => {
				this.getClassInfo()
			}
		)
	}

	// 获取课程详情
	public async getClassInfo() {
		const from: FormData = new FormData()
		from.append('id', '1')
		from.append('role', 'user')
		from.append('nickname', 'student')
		from.append('course_id', this.state.classId)

		let res = await axios({
			url:
				'https://v2ctest.yunkaodian.com/app/Course/getPublicLiveCloudUserAccess',
			data: from,
			method: 'POST',
		})

		if (res.data.ret === 200) {
			let access_token = res.data.data.access_token
			let courseData = await axios.get(
				`https://room.yunkaodian.com/room/${access_token}`
			)
			if (courseData.data.code === 200) {
				let courseInfo = JSON.parse(
					Base64.decode(
						courseData.data.data.substring(0, 6) +
							courseData.data.data.slice(7)
					)
				)
				if (
					new Date(courseInfo.course.end_time).getTime() <
						new Date().getTime() + 20 * 60 * 1000 &&
					!courseInfo.course.is_live
				) {
					this.setState({
						is_live: false,
						url: `https://live.yunkaodian.com/new/playback/${access_token}`,
					})
				} else {
					this.setState({
						is_live: true,
					})
				}
			}
		}
	}

	// 进入回放
	public entryPlay() {
		window.location.href = this.state.url
	}

	// 进入直播
	public entryLive() {
		if (!this.state.username || !this.state.classId) {
			message.warn('请输入昵称和课程号')
			return
		}
		const from: FormData = new FormData()
		let id: any = Math.floor(Math.random() * 1000000) + 1000000
		from.append('id', id)
		from.append('role', 'user')
		from.append('nickname', this.state.username)
		from.append('course_id', this.state.classId)
		axios({
			url:
				'https://v2ctest.yunkaodian.com/app/Course/getPublicLiveCloudUserAccess',
			data: from,
			method: 'POST',
		}).then((res: any) => {
			if (res.data.ret === 200) {
				let url = res.data.data.liveUrl
				if (url) {
					// return
					window.location.href = url
				}
			}
		})
	}

	public render() {
		return (
			<div className="entry">
				<h4>欢迎来到直播间</h4>
				<ClassInfo
					courseName={this.state.courseName}
					lecturer={this.state.lecturer}
					time={this.state.time}
					is_live={this.state.is_live}
				/>
				<div className="form">
					{/* <label>
						<span>课程号：</span>
						<input
							id="classId"
							disabled
							type="text"
							name="classId"
							value={this.state.classId}
							onChange={this.handleInputChange}
							placeholder="请输入课程号!"
						/>
					</label> */}
					<label className={this.state.is_live ? '' : 'none'}>
						<span>昵称：</span>
						<input
							type="text"
							name="username"
							onBlur={(e: any) => {
								if (!this.state.username) {
									let input: any = e.target
									let iEle: any = document.getElementById(
										'tip1'
									)
									input.setAttribute('class', 'error')
									iEle.removeAttribute('class', 'error')
								}
							}}
							onFocus={(e: any) => {
								let input: any = e.target
								let iEle: any = document.getElementById('tip1')
								if (input.getAttribute('class')) {
									input.removeAttribute('class')
									iEle.setAttribute('class', 'none')
								}
							}}
							value={this.state.username}
							onChange={this.handleInputChange}
							placeholder="请输入您的昵称!(1~8个字符)"
							autoComplete="off"
						/>
						<i className="none" id="tip1">
							请输入昵称！
						</i>
					</label>
					<label className="none">
						<span>密码：</span>
						<input
							type="password"
							name="password"
							onBlur={(e: any) => {
								if (!this.state.password) {
									let input: any = e.target
									let iEle: any = document.getElementById(
										'tip2'
									)
									input.setAttribute('class', 'error')
									iEle.removeAttribute('class', 'error')
								}
							}}
							onFocus={(e: any) => {
								let input: any = e.target
								let iEle: any = document.getElementById('tip2')
								if (input.getAttribute('class')) {
									input.removeAttribute('class')
									iEle.setAttribute('class', 'none')
								}
							}}
							value={this.state.password}
							onChange={this.handleInputChange}
							placeholder="请输入您的昵称!(1~8个字符)"
							autoComplete="off"
						/>
						<i className="none" id="tip2">
							请输入密码！
						</i>
					</label>
					{this.state.is_live ? (
						<button onClick={this.entryLive}>进入直播</button>
					) : (
						<button onClick={this.entryPlay}>观看回放</button>
					)}
				</div>
			</div>
		)
	}
}

export default Entry
